import { useTheme } from '@nexelem/deprecated-theme';
import { useAppBarHeight } from '@nexelem/appbar';
import { LoaderResult } from '@nexelem/navigation';
import { Suspense, useMemo, ReactNode } from 'react';
import { Await, Navigate, useLoaderData, useLocation } from 'react-router-dom';
import { getAbsolutePath, ROUTES } from '../../../routes/config';
import { CommonLoader } from '../CommonLoader';
import { useAuthContext } from '../../../providers/AuthProvider';
import { AnyProps } from '@nexelem/utils';

type SuspensePageProps = {
  children: (props: AnyProps) => ReactNode;
  isProtected?: boolean;
};
export const SuspensePage = ({ children, isProtected }: SuspensePageProps) => {
  const { spacing } = useTheme();
  const { appBarHeight } = useAppBarHeight();
  const { userState, user } = useAuthContext();
  const location = useLocation();
  const { result } = (useLoaderData() || {}) as LoaderResult;

  const height = useMemo(() => `calc(100vh - (${appBarHeight}px + ${spacing(6.5)}))`, [appBarHeight, spacing]);

  if (userState.isLoading) {
    // waiting for user to be logged in or not
    return <CommonLoader />;
  }
  if (isProtected && !user) {
    return <Navigate replace state={{ location }} to={getAbsolutePath(ROUTES.login)} />;
  }

  return (
    <Suspense fallback={<CommonLoader height={height} />}>
      <Await resolve={result}>{children}</Await>
    </Suspense>
  );
};
